/*
 * Kickflip × Monster Cart — correzione prezzi nel cassetto
 * I prodotti Kickflip hanno prezzo variante 0 €: il prezzo reale lo applica Kickflip
 * (cart transform) ed è corretto in /cart.js, ma il cassetto Monster mostra 0 €.
 * Questo script, a ogni rendering del cassetto, legge /cart.js e riscrive:
 *   - il prezzo delle righe (b.mu-item-price) con final_line_price
 *   - subtotale / totale / pulsante pagamento con total_price
 *   - la barra della spedizione gratuita, quando il totale reale supera la soglia
 * Agisce solo se nel carrello c'è almeno una riga Kickflip (_mczr_*).
 * Il checkout non è toccato: usa già il prezzo corretto.
 */
(function () {
  "use strict";

  // Soglia e messaggi come configurati in Monster Cart (aggiornarli se cambiano nell'app)
  var FREE_SHIPPING_GOAL_CENTS = 5500;
  var GOAL_REACHED_TEXT = {
    it: "Congratulazioni! Il tuo ordine ha diritto alla spedizione gratuita",
    en: "Congratulations! Your order qualifies for free shipping"
  };

  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || "/";
  var origFetch = window.fetch;
  var cart = null;        // ultimo /cart.js letto
  var loading = null;

  function isKickflip(item) {
    return Object.keys(item.properties || {}).some(function (k) { return k.indexOf("_mczr") === 0; });
  }

  // Formato prezzo di Monster (es. "€{{amount_with_comma_separator}}")
  function formatMoney(cents) {
    var format = window.mu_money_format || "€{{amount_with_comma_separator}}";
    function fmt(n, decimals, thousands, decimal) {
      var parts = (n / 100).toFixed(decimals).split(".");
      var int = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return int + (parts[1] ? decimal + parts[1] : "");
    }
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case "amount_no_decimals":                        return fmt(cents, 0, ",", ".");
        case "amount_with_comma_separator":               return fmt(cents, 2, ".", ",");
        case "amount_no_decimals_with_comma_separator":   return fmt(cents, 0, ".", ",");
        case "amount_with_apostrophe_separator":          return fmt(cents, 2, "'", ".");
        case "amount_with_space_separator":               return fmt(cents, 2, " ", ",");
        default:                                          return fmt(cents, 2, ",", ".");
      }
    });
  }

  function setText(el, text) {
    if (el && el.textContent !== text) el.textContent = text;
  }

  function apply() {
    var w = document.getElementById("monster-cart-wrapper");
    if (!w || !cart || !(cart.items || []).some(isKickflip)) return;

    // Righe: abbina per variante, nell'ordine (più righe Kickflip hanno la stessa variante)
    var seen = {};
    w.querySelectorAll("#mu-items-container .mu-cart-item[data-variant-id]").forEach(function (row) {
      var vid = row.getAttribute("data-variant-id");
      var n = seen[vid] = (seen[vid] || 0) + 1;
      var matches = cart.items.filter(function (i) { return String(i.variant_id) === vid; });
      var item = matches[n - 1];
      if (item && isKickflip(item)) setText(row.querySelector(".mu-item-price"), formatMoney(item.final_line_price));
    });

    // Subtotale, totale e pulsante pagamento
    var total = formatMoney(cart.total_price);
    w.querySelectorAll(".mu-subtotal span[data-value], .mu-total span[data-value]").forEach(function (el) {
      if (el.getAttribute("data-value") !== total) el.setAttribute("data-value", total);
      setText(el, total);
    });
    var btn = document.getElementById("mu-checkout-button");
    if (btn && btn.getAttribute("data-display") !== total) btn.setAttribute("data-display", total);

    // Barra spedizione gratuita: Monster la calcola sul suo totale (senza Kickflip)
    if (cart.total_price >= FREE_SHIPPING_GOAL_CENTS) {
      var lang = ((window.Shopify && Shopify.locale) || document.documentElement.lang || "it").slice(0, 2);
      var msg = GOAL_REACHED_TEXT[lang] || GOAL_REACHED_TEXT.it;
      setText(w.querySelector(".mu-goal-text p"), msg);
      var bar = w.querySelector(".mu-progress-bar");
      if (bar && bar.style.width !== "100%") bar.style.width = "100%";
    }
  }

  function refreshCart() {
    if (loading) return loading;
    loading = origFetch.call(window, ROOT + "cart.js?_=" + Date.now(), { cache: "no-store", headers: { Accept: "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (c) { cart = c; apply(); })
      .catch(function (e) { console.warn("[kickflip-monster]", e); })
      .then(function () { loading = null; });
    return loading;
  }

  // Ricarica il carrello dopo ogni modifica
  var MUTATION_RE = /\/cart\/(add|change|update|clear)(\.js)?\/?$/;
  function isMutation(url) {
    try { return MUTATION_RE.test(new URL(url, location.href).pathname); } catch (e) { return false; }
  }
  if (origFetch) {
    window.fetch = function (input) {
      var url = typeof input === "string" ? input : (input && (input.href || input.url));
      var p = origFetch.apply(this, arguments);
      if (isMutation(url)) p.then(function (res) { if (res.ok) setTimeout(refreshCart, 200); }, function () {});
      return p;
    };
  }
  var origOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    if (isMutation(url)) this.addEventListener("load", function () { setTimeout(refreshCart, 200); });
    return origOpen.apply(this, arguments);
  };

  // Ogni volta che Monster ridisegna il cassetto, riapplica i prezzi corretti
  var scheduled = false;
  new MutationObserver(function () {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      if (!document.getElementById("monster-cart-wrapper")) return;
      if (cart) apply(); else refreshCart();
    });
  }).observe(document.documentElement, {
    childList: true, subtree: true, characterData: true,
    attributes: true, attributeFilter: ["style", "data-value", "data-display"]
  });

  refreshCart();

  // Per test da console: KickflipMonster.refresh()
  window.KickflipMonster = { refresh: refreshCart, apply: apply, formatMoney: formatMoney };
})();
